import CabecalhoElemento from "../CabecalhoElemento";

export const headerClick = (self, evento, coluna) => {
  if(coluna._column.definition.ordena && self.paginacaoRemota){ //TODO: Fazer ordenação local
    let sorters = self.tabulator.getSorters();
    if(!sorters.length) return; // se não houver ordenadores retorna e não faz nada.
    let ordenador = sorters[0];
    let campoOrdenado = ordenador.column._column.definition;
    let crescente = ordenador.dir === 'asc'


    self.parametros.Ordenacao.campo = campoOrdenado.ordena
    self.parametros.Ordenacao.crescente = crescente


    if(!self.ordenacaoAtual.campo) self.ordenacaoAtual.campo = campoOrdenado.ordena;

    if(campoOrdenado.ordena != self.ordenacaoAtual.campo){
      self.ordenacaoAtual.ordenacoesAnteriores = [];
    }

    self.ordenacaoAtual.campo = campoOrdenado.ordena;
    self.ordenacaoAtual.ordenacoesAnteriores.push(crescente ? 'asc' : 'desc')

    if(self.ordenacaoAtual.ordenacoesAnteriores.length >= 3 ){
      self.resetOrdenacao();
      ordenador.dir = 'reset' // se a ordenação resetou, as classes também precisam resetar
      self.tabulator.clearSort();
    }

    //id do cabeçalho que vai ordenar a busca
    const elementoId = `#icones-${campoOrdenado.field}`;

    //elemento HTML do container dos icones ("pai das setinhas")
    const containerIcones = document.querySelector(elementoId);

    //procurando ele no cache
    let cabecalhoElemento = self.cabecalhosOrdenados.find(x => x.id == elementoId)

    //Se não achou, adiciona na lista
    const elementoJaAdicionado = cabecalhoElemento !== undefined;
    if(!elementoJaAdicionado) {
      cabecalhoElemento = new CabecalhoElemento(containerIcones, elementoId)
      self.cabecalhosOrdenados.push(cabecalhoElemento)
    }

    //executando troca de classes
    cabecalhoElemento[ordenador.dir]()

    self.cabecalhosOrdenados.filter(x => x.id != elementoId).forEach(a => a.reset())

    self.buscaDados();
  }
}